function normalizeCloudUrl(url: string | undefined): string {
  return String(url || '').trim().replace(/\/$/, '');
}

/** Build-time cloud URL (apps/admin-web/.env.*). May include path prefix. */
export const ADMIN_CLOUD_URL = normalizeCloudUrl(import.meta.env.VITE_BOCOVE_CLOUD_URL);

/** Dev: same-origin /v1 via Vite proxy; production: absolute cloud URL. */
export const CLOUD_CLIENT_BASE_URL = import.meta.env.DEV ? '' : ADMIN_CLOUD_URL;

/** Must not collide with portal/website user session keys. */
export const ADMIN_TOKEN_KEY = 'bocove-admin-token';
